export default __webpack_public_path__ + "static/media/scream.513d04fd.png";